import Welcome from '../pages/getting-started/Welcome'
import Onboarding from '../pages/getting-started/Onboarding.jsx'
import HomeScreen from '../pages/getting-started/HomeScreen'
import FindingYourWay from '../pages/getting-started/FindingYourWay.jsx'
import GlobalOverview from '../pages/getting-started/GlobalOverview.jsx'
import Wallboards from '../pages/getting-started/Wallboards.jsx'
import Permissions from '../pages/getting-started/Permissions.jsx'

export default [
  {
    id: 'welcome',
    title: 'Welcome to AmbuNet',
    summary:
      'Overview of AmbuNet, who it is for, how access varies by permissions, subscription tier, base location, and configuration — and where to start as a new admin or crew member.',
    component: Welcome,
    tags: ['Overview', 'Getting Started', 'Modules', 'Where To Start'],
  },
  {
    id: 'onboarding',
    title: 'Onboarding Your Organisation',
    summary:
      'The two-phase setup for a new organisation: the first-sign-in setup wizard (company info, base location, teams and roles), then the Getting Started checklist that ticks itself off as you add data.',
    component: Onboarding,
    tags: [
      'Onboarding',
      'Setup',
      'Setup Wizard',
      'Getting Started Checklist',
      'Base Locations',
      'Teams',
      'Clinical Roles',
    ],
  },
  {
    id: 'home-screen',
    title: 'Home Screen',
    summary:
      'What the AmbuNet home screen shows: the To Do bar, On Call Now, Active Shift clock in and out, the Active CAD Resource and CQC Readiness cards, Quick Links, and Team Actions — and how it changes with your role.',
    component: HomeScreen,
    tags: [
      'Home Screen',
      'Quick Links',
      'To Do',
      'Team Actions',
      'On Call',
      'On-Call',
      'Active Shift',
      'Clock In',
      'Clock Out',
      'CQC Readiness',
      'Active Resource',
    ],
  },
  {
    id: 'finding-your-way',
    title: 'Finding Your Way Around',
    summary:
      'Get anywhere fast: the ⌘K global search (pages, create actions, knowledgebase, people, vehicles, events, PTS bookings), the sidebar with badges, favourites and recents, the Quick Add menu, the contextual help drawer, the notifications page, the favourites bar, the sitemap, and your default landing page.',
    component: FindingYourWay,
    tags: [
      'Navigation',
      'Search',
      'Global Search',
      'Cmd K',
      'Sidebar',
      'Favourites',
      'Recents',
      'Quick Add',
      'Help',
      'Notifications',
      'Sitemap',
      'Landing Page',
      'Preferences',
      'Badges',
    ],
  },
  {
    id: 'global-overview',
    title: 'Global Overview',
    summary:
      'The organisation-wide management dashboard for the Manager and Supervisor teams: headline stats, KPI health, shift and incident trends, fleet readiness, and a needs-your-attention list.',
    component: GlobalOverview,
    tags: [
      'Global Overview',
      'Dashboard',
      'Managers',
      'KPIs',
      'Fleet Readiness',
      'Attention',
    ],
  },
  {
    id: 'wallboards',
    title: 'Wallboards',
    summary:
      'Turn a TV into a full-screen rotating display of live AmbuNet data — setting up and authorising a display without leaving anyone signed in, building screens in the drag-and-drop editor, the available widgets, shoutouts, themes, and revoking devices.',
    component: Wallboards,
    tags: [
      'Wallboard',
      'TV',
      'Display',
      'Screens',
      'Widgets',
      'Shoutouts',
      'Devices',
      'Crew Room',
      'Dashboard',
    ],
  },
  {
    id: 'permissions',
    title: 'Permissions & Roles',
    summary:
      'Searchable reference of every AmbuNet action and the team, role, or access level it requires — including Command & Control tiers, the PTS Co-Ordinator level, MFA-protected areas, the Manage Access matrix, and Site Admin powers.',
    component: Permissions,
    tags: [
      'Permissions',
      'Roles',
      'Teams',
      'Security',
      'User',
      'Access',
      'Manage Access',
      'Site Admin',
      'MFA',
      'Safeguarding',
    ],
  },
]
